<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <ng-container *ngIf="canBeIndeterminate; then complex; else simple"> </ng-container>

    <ng-template #complex>
        <sh-form-list-complex-base
            [id]="controlId"
            [fieldType]="fieldType"
            [formControl]="control"
            [required]="isControlRequired$ | async"
            [placeholderMsg]="placeholderMsg"
            [duplicateErrorMsg]="duplicateErrorMsg"
            [indeterminateMsg]="indeterminateMsg"
            [disabledMsg]="disabledMsg"
            [sanitizeFct]="sanitizeFct"
            [autocompleteFct]="autocompleteFct"
        ></sh-form-list-complex-base>
    </ng-template>

    <ng-template #simple>
        <sh-form-list-base
            [id]="controlId"
            [fieldType]="fieldType"
            [formControl]="control"
            [required]="isControlRequired$ | async"
            [placeholderMsg]="placeholderMsg"
            [duplicateErrorMsg]="duplicateErrorMsg"
            [disabledMsg]="disabledMsg"
            [sanitizeFct]="sanitizeFct"
            [autocompleteFct]="autocompleteFct"
        ></sh-form-list-base>
    </ng-template>
</sh-form-group>
